<template slot-scope="props">
    <button
            :class="{ 'btn': true,
                     'btn-primary': classDefault === 'btn-primary',
                     'btn-secondary': classDefault === 'btn-secondary',
                     'btn-success': classDefault === 'btn-success',
                     'btn-warning': classDefault === 'btn-warning',
                     'btn-danger': classDefault === 'btn-danger',
                     'vue-btn-loader-error': !isSuccess && !emptyStatus, 
                     'vue-btn-loader-success': isSuccess, 
                     'is-loading': isLoading}">

        <transition name="fade" mode="out-in">
            <div :class="{ 'spinner': loading, 'check': !emptyStatus && isSuccess && !loading, 'cross': !emptyStatus && !isSuccess && !loading }"></div>
        </transition>

        <slot v-if="showSlot"></slot>
    </button>
</template>

<script>
  export default {
    name: 'vue-button-spinner',
    props: {
      isLoading: {
        type: Boolean,
        default: false
      },
      status: {
        type: [String, Boolean],
        default: ''
      },
      classDefault: {
        type: [String],
        default: 'btn-success'
      }
    },
    computed: {
      loading () {
        return this.isLoading
      },
      isSuccess () {
        return this.status === 'success' || this.status === true
      },
      emptyStatus () {
        return !this.status.length
      },
      showSlot () {
        return this.isSuccess || this.loading || this.emptyStatus
      }
    }
  }
</script>

<style lang="css" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-active {
        opacity: 0;
        will-change: opacity;
    }
    @keyframes rotation {
        from {
            transform: rotate(0deg)
        }
        to {
            transform: rotate(359deg)
        }
    }
    
    .vue-btn {
        /*Nao Estou usando mais usei agora o btn e btn-sucess para padronizar*/
        -moz-appearance: none;
        -webkit-appearance: none;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-radius: 0px;
        -webkit-box-shadow: none;
        box-shadow: none;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        font-size: 1rem;
        height: 2.25em;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        line-height: 1.5;
        padding-bottom: calc(0.375em - 1px);
        padding-left: calc(0.625em - 1px);
        padding-right: calc(0.625em - 1px);
        padding-top: calc(0.375em - 1px);
        position: relative;
        vertical-align: top;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: white;
        border: 1px solid #dbdbdb;
        cursor: pointer;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding-left: 0.75em;
        padding-right: 0.75em;
        text-align: center;
        white-space: nowrap;
        transition: .3s all ease;
        background-color: #4dbd74;
        border-color: #4dbd74;
        color: #fff;
    }
    .is-loading {
        cursor: not-allowed;
        background-color : #dbdbdb;
        border-color: #dbdbdb;
        color: #363636;
        display: inline-flex;
    }

    button.vue-btn-loader-error:not(.is-loading) {
        background-color: #F44336;
        border-color: #F44336;
    }
    button.vue-btn-loader-success:not(.is-loading) {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #fff;
    }
    button.vue-btn:disabled {
        cursor: not-allowed;
        background-color: none;
    }
    /**
        Spinner Icon
    **/
    .spinner {
        height: 20px;
        width: 20px;
        margin-right: 8px;
        opacity: 1;
        filter: alpha(opacity=100);
        animation: rotation .7s infinite linear;
        border: 4px solid rgba(0, 0, 0, 0.2);
        border-top-color: #fff;
        border-radius: 100%;
        transition: .3s all ease;
    }
    /**
        Check Icon
    **/
    .check {
        display: inline-block;
        width: 28px;
        height: 17px;
        border-radius: 50%;
        transform: rotate(45deg);
        color: white;
        will-change: transform;
    }
    .check:before {
        content: "";
        position: absolute;
        width: 3px;
        height: 9px;
        background-color: #fff;
        left: 11px;
        top: 6px;
    }
    .check:after {
        content: "";
        position: absolute;
        width: 3px;
        height: 3px;
        background-color: #fff;
        left: 8px;
        top: 12px;
    }
    /**
        Cross Icon
    **/
    .cross {
        display: inline-block;
        width: 17px;
        height: 16px;
        position: relative;
    }
    .cross:before, .cross:after {
        position: absolute;
        left: 8px;
        content: ' ';
        height: 16px;
        width: 2px;
        background-color: #fff;
    }
    .cross:before {
        transform: rotate(45deg);
        will-change: transform;
    }
    .cross:after {
        transform: rotate(-45deg);
        will-change: transform;
    }
</style>


// WEBPACK FOOTER //
// src/components/VueButtonSpinner.vue